export default __webpack_public_path__ + "static/media/NoProjectMissingPlan.8ee4dcb2.svg";